'use client';

import { EventMykissCardClicked } from '@generated/events';
import { FishingWaterCarouselItem } from '../../generated/graphql';
import { FishingWaterCard } from '../Cards/FishingWaterCard/FishingWaterCard';
import { ContinuousCarousel } from '../Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../Container/Container';
import { firstNonEmpty } from '@lib/strings/firstNonEmpty';

export interface IFishingWaterCarouselProps {
  dataTestId: string;
  title: string;
  waters?: FishingWaterCarouselItem[];
  isLoading?: boolean;
  /* An identifier for where this carousel is being used, e.g. species-top-waters */
  clickEventSource: EventMykissCardClicked['properties']['source'];
  /* An ID of the resource type where this carousel is being used, e.g. a species ID if it's on a species page */
  clickEventSourceId?: EventMykissCardClicked['properties']['source_id'];
  outerClassName?: string;
  /* Use if carousel shown above the fold */
  preload?: boolean;
}

export const FishingWaterCarousel = ({
  dataTestId,
  title,
  waters = [],
  isLoading = false,
  clickEventSource,
  clickEventSourceId,
  outerClassName,
  preload = false,
}: IFishingWaterCarouselProps) => {
  return (
    <Container>
      <ContinuousCarousel
        dataTestId={dataTestId}
        title={title}
        outerClassName={outerClassName}
        showContentLoader
        isLoading={isLoading}
      >
        {waters.map((water, index) => {
          const isPreload = index === 0 && preload;
          return (
            <FishingWaterCard
              key={`${dataTestId}-${water._id}`}
              imageWidth={372}
              latitude={water.latitude}
              longitude={water.longitude}
              clickEventSource={clickEventSource}
              name={water.displayName}
              numberOfCatches={water.catchesCount}
              waterId={water._id}
              clickEventPosition={index}
              clickEventSourceId={clickEventSourceId}
              countryName={water.country?.countryName}
              regionName={firstNonEmpty(water.region?.localName, water.region?.name) || undefined}
              preload={isPreload}
            />
          );
        })}
      </ContinuousCarousel>
    </Container>
  );
};
